<template>
  <v-app>
    <view-as-role-banner v-if="isAuth"></view-as-role-banner>
    <header-comp v-if="isAuth && showHeader"></header-comp>
    <app-notifications></app-notifications>
    <side-bar v-if="isAuth"></side-bar>

    <v-main>
      <router-view v-if="!loading" :class="isAuth? '' : 'red darken-3'"></router-view>
      <card-loading-transparent v-if="loading" class="pt-8"></card-loading-transparent>
    </v-main>
    
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Api from '@/api/index';
import change_module from "@/mixins/change_module.js"

export default {
  name: "App",
  mixins:[ change_module ],
  components: {
    AppNotifications: () =>import('./components/notification/Notifications'),
    ViewAsRoleBanner: () => import("@/components/shared/ViewAsRoleBanner.vue"),
    HeaderComp: () => import("@/components/shared/_header_01.vue"),
    SideBar: () => import("@/components/shared/_drawer_01.vue"),
  },
  data(){
    return {
      interval: null,
      loading: false,
      hide_header_routes: ["PrintShipping", "CreateOrder", "HomeClientOrderDetails", "ClientOrderHome", "UnauthorizedClientOrderDetails"]
    }
  },
  methods: {
    getProfile(){
      this.loading = true
      Api.User.profile().then(r=> r.data).then(d=> {
        this.$store.dispatch("User/setCurrentUser", d);
        this.loading = false
      }).catch(err=>{
        console.log(err)
        this.$router.push({name: 'Login'})
      })
    },
    ...mapActions({
      setactiveModalityId: 'App/setactiveModalityId',
      indexStatus: 'Status/index',
    })
  },

  computed: {
    showHeader(){
      return !this.hide_header_routes.includes(this.$route.name)
    },
    authReady() {
      return !this.$auth0.isLoading;
    },
    isAuth() {
      return this.$auth0.isAuthenticated;
    },
  },
  beforeDestroy(){
    clearInterval(this.interval)
  },
  mounted () {
    this.$moment.locale('pt-BR');
    if (this.$auth0.isAuthenticated){
      this.getProfile()
    } else {
    }
  },
  watch: {
    isAuth(nv){
      if (nv){
        this.$store.dispatch("User/setCurrentUser", this.$auth0.user);
        this.getProfile()
      }
    },
    authReady(val) {
      if (val) {
        if (this.$auth0.isAuthenticated){
          this.$store.dispatch("User/setCurrentUser", this.$auth0.user);
          this.getProfile()
        }
      }
    },

  }
};
</script>
<style>
@import './assets/styles/app.css';
html {
  overflow-y: auto !important;
}
</style>
